import { IApplicationState } from '../../types/redux';

export const getBuilderChatOpened = (state: IApplicationState): boolean => state.builderChat.isOpened;
